__turbopack_context__.v({
  "blinking": "DotLoader-module-scss-module__kthnZa__blinking",
  "dot": "DotLoader-module-scss-module__kthnZa__dot",
  "dotsContainer": "DotLoader-module-scss-module__kthnZa__dotsContainer",
});
